import { createDeletablePermission } from "@/permissions/shared/createDeletablePermission";
import { useActivitiesStore } from "@/stores/activities.module";

export function useActivitiesPermissions() {
  const store = useActivitiesStore();

  const deletable = createDeletablePermission(store);

  return { deletable };
}
